(() => {
  const match = location.pathname.match(/\/products\/([^/?#]+)/);
  const handle = match ? match[1] : '';
  if (!window.SmoofProductProfiles?.isTestProfile?.(handle)) return;
  if (window.__smoofLayerOpacityV20) return;
  window.__smoofLayerOpacityV20 = true;

  const DEFINITIONS = Object.freeze({
    'text-0': { property: 'properties[_SMOOF Deckkraft Text 1]', selectors: ['[data-smoof-text-content="0"]', '[data-smoof-text-pill="0"]', '[data-smoof-inline-text-input="0"]'] },
    'text-1': { property: 'properties[_SMOOF Deckkraft Text 2]', selectors: ['[data-smoof-text-content="1"]', '[data-smoof-text-pill="1"]', '[data-smoof-inline-text-input="1"]'] },
    'text-2': { property: 'properties[_SMOOF Deckkraft Text 3]', selectors: ['[data-smoof-text-content="2"]', '[data-smoof-text-pill="2"]', '[data-smoof-inline-text-input="2"]'] },
    'arrow-left': { property: 'properties[_SMOOF Deckkraft Piktogramm links]', selectors: ['[data-smoof-arrow-graphic="left"]', '[data-smoof-arrow-label-graphic="left"]'] },
    'arrow-right': { property: 'properties[_SMOOF Deckkraft Piktogramm rechts]', selectors: ['[data-smoof-arrow-graphic="right"]', '[data-smoof-arrow-label-graphic="right"]'] },
    logo: { property: 'properties[_SMOOF Deckkraft Logo]', selectors: ['[data-smoof-logo-editor-frame]:not([data-smoof-logo-instance]) > img', '[data-smoof-logo-background="logo"]'] },
    'logo-copy': { property: 'properties[_SMOOF Deckkraft Logo 1 Duplikat]', selectors: ['[data-smoof-logo-instance="copy"] > img', '[data-smoof-logo-background="logo-copy"]'] },
    'logo-2': { property: 'properties[_SMOOF Deckkraft Logo 2]', selectors: ['[data-smoof-logo-instance="2"] > img', '[data-smoof-logo-background="logo-2"]'] },
    'table-number': { property: 'properties[_SMOOF Deckkraft Nummer]', selectors: ['[data-smoof-number-content]', '[data-smoof-number-inline-input]'] },
    payments: { property: 'properties[_SMOOF Deckkraft Zahlungsanbieter]', selectors: ['[data-smoof-payment-frame]'] },
    'branding-dot': { property: 'properties[_SMOOF Deckkraft Branding-Kreis]', selectors: ['[data-smoof-brand-dot]'] },
    nfc: { property: 'properties[_SMOOF Deckkraft NFC]', selectors: ['[data-smoof-nfc-frame]'] },
    background: { property: 'properties[_SMOOF Deckkraft Hintergrund]', selectors: ['[data-smoof-background-color]'] }
  });

  const state = Object.fromEntries(Object.keys(DEFINITIONS).map(id => [id, 1]));
  let hydrated = false;
  let applyPending = false;

  function clampOpacity(value) {
    const clamped = Math.min(1, Math.max(0, Number(value) || 0));
    return Math.round(clamped * 100) / 100;
  }

  function productForm() {
    return Array.from(document.querySelectorAll('form[action*="/cart/add"]'))
      .find(form => form.querySelector('button[type="submit"]')) || null;
  }

  function propertyInput(name) {
    return Array.from((productForm() || document).querySelectorAll('input'))
      .find(input => input.name === name) || null;
  }

  function setProperty(name, value) {
    const form = productForm();
    if (!form) return;
    let input = propertyInput(name);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.dataset.smoofLayerOpacityProperty = 'true';
      form.appendChild(input);
    }
    input.value = Number(value).toFixed(4);
  }

  function hydrate() {
    if (hydrated || !productForm()) return;
    Object.entries(DEFINITIONS).forEach(([id, definition]) => {
      const value = Number.parseFloat(propertyInput(definition.property)?.value);
      state[id] = Number.isFinite(value) ? clampOpacity(value) : 1;
    });
    hydrated = true;
  }

  function syncProperties() {
    hydrate();
    Object.entries(DEFINITIONS).forEach(([id, definition]) => {
      setProperty(definition.property, state[id]);
    });
  }

  function applyToDom() {
    applyPending = false;
    hydrate();
    Object.entries(DEFINITIONS).forEach(([id, definition]) => {
      const value = String(state[id]);
      definition.selectors.forEach(selector => {
        document.querySelectorAll(selector).forEach(element => {
          if (element.style.opacity !== value) element.style.opacity = value;
          element.dataset.smoofLayerOpacity = value;
        });
      });
    });
    syncProperties();
  }

  function scheduleApply() {
    if (applyPending) return;
    applyPending = true;
    requestAnimationFrame(applyToDom);
  }

  function notify(id) {
    scheduleApply();
    syncProperties();
    window.SmoofDesignRenderer?.scheduleRender?.();
    window.dispatchEvent(new CustomEvent('smoof:layer-opacity-changed', {
      detail: { id, opacity: state[id] }
    }));
  }

  window.SmoofLayerOpacityTools = Object.freeze({
    supports(id) {
      return Boolean(DEFINITIONS[id]);
    },
    get(id) {
      hydrate();
      return DEFINITIONS[id] ? state[id] : 1;
    },
    set(id, value) {
      if (!DEFINITIONS[id]) return false;
      hydrate();
      state[id] = clampOpacity(value);
      notify(id);
      return state[id];
    },
    getHistoryState() {
      hydrate();
      return { ...state };
    },
    applyHistoryState(next) {
      if (!next || typeof next !== 'object') return false;
      Object.keys(DEFINITIONS).forEach(id => {
        if (Number.isFinite(Number(next[id]))) state[id] = clampOpacity(next[id]);
      });
      notify('history');
      return true;
    },
    reset(id) {
      if (id && DEFINITIONS[id]) {
        state[id] = 1;
        notify(id);
        return true;
      }
      Object.keys(DEFINITIONS).forEach(key => { state[key] = 1; });
      notify('all');
      return true;
    }
  });

  ['smoof:editor-reset-all', 'smoof:editor-reset-content'].forEach(eventName => {
    window.addEventListener(eventName, () => window.SmoofLayerOpacityTools.reset());
  });
  new MutationObserver(scheduleApply).observe(document.body, { childList: true, subtree: true });
  window.setInterval(scheduleApply, 500);
  scheduleApply();
})();
